import { TFunction } from 'i18next'

import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'

import { DownloadDocumentFileType } from '../enums/downloadDocumentFileType'
import { ZervantLocale } from '../enums/zervantLocale'
import { getDocumentName } from './getDocumentName'

interface GetInvoiceDocumentNameOptions {
  downloadDocumentFileType: DownloadDocumentFileType
  documentLocale?: ZervantLocale
  documentType: InvoiceDocumentType
  invoiceNumber?: string | null
  organizationName?: string
  t: TFunction
}

export const getDownloadDocumentFileName = ({
  downloadDocumentFileType,
  documentLocale,
  documentType,
  invoiceNumber,
  organizationName,
  t,
}: GetInvoiceDocumentNameOptions) => {
  const name = getDocumentName({ documentLocale, documentType, invoiceNumber, organizationName, t })

  return `${name}.${downloadDocumentFileType}`
}
